import Firebase from 'firebase'

const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://mhckv4wz8lb18307ig6f.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
})

const logs = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://logskne.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
}, 'logs')

const archives = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://archiveskne.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
}, 'archives')

// // Export the database for components to use.
// // If you want to get fancy, use mixins or provide / inject to avoid redundant imports.

export const db = firebaseApp.database()
export const dbLogs = logs.database()
export const dbArchives = archives.database()



// WEBPACK FOOTER //
// ./src/firebase.js